import { QuoteRepriceLink } from 'components/shared/QuoteRepriceLink/QuoteRepriceLink';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import type { AppState } from 'state/state.model';
import { getDiscoveryUrl } from 'state/user';

import type { PriceImprovementSummaryProps } from './priceImprovementSummary.connect';
import { connectPriceImprovementSummary } from './priceImprovementSummary.connect';

export const PriceImprovementSummaryRaw: FC<PriceImprovementSummaryProps> = ({
  quoteId,
  pricerId,
  salesDesk,
  salesName,
  salesComment,
  underlyings,
}) => {
  const { formatMessage } = useIntl();
  const discoveryUrl = useSelector((state: AppState) => getDiscoveryUrl(state)) || '#';

  return (
    <ul className="list-group list-group-flush overflow-y-auto border-top" data-e2e="quote-details">
      <li
        className="list-group-item border-bottom d-md-flex justify-content-md-between ps-0 pe-3"
        data-e2e="quote-external-id"
      >
        <span className="text-secondary">{formatMessage({ id: 'blotterPanel.externalQuoteId' })}</span>

        <QuoteRepriceLink quoteId={quoteId} externalQuoteId={quoteId} canCopy={false} />
      </li>
      <li
        className="list-group-item border-bottom d-md-flex justify-content-md-between ps-0 pe-3"
        data-e2e="pricer-rfq-id"
      >
        <span className="text-secondary">{formatMessage({ id: 'blotterPanel.pricerRfqId' })}</span>
        <div>
          <span className="text-truncate">{pricerId}</span>
          <a
            href={`${discoveryUrl}/#/identities?codes=${underlyings}`}
            className="ms-1"
            target="_blank"
            title={formatMessage({ id: 'priceImprovementBlotter.link.discover' })}
          >
            <i className="icon icon-sm">launch</i>
          </a>
        </div>
      </li>
      <li
        className="list-group-item border-bottom d-md-flex justify-content-md-between ps-0 pe-3"
        data-e2e="sales-desk"
      >
        <span className="text-secondary">{formatMessage({ id: 'blotterPanel.salesDesk' })}</span>
        <div className="text-truncate">
          <span>{salesDesk}</span>
        </div>
      </li>
      <li
        className="list-group-item border-bottom d-md-flex justify-content-md-between ps-0 pe-3"
        data-e2e="sales-name"
      >
        <span className="text-secondary">{formatMessage({ id: 'blotterPanel.salesName' })}</span>
        <div className="text-truncate">
          <span>{salesName}</span>
        </div>
      </li>
      <li
        className="list-group-item border-bottom d-md-flex justify-content-md-between ps-0 pe-3"
        data-e2e="sales-comment"
      >
        <span className="text-secondary">{formatMessage({ id: 'blotterPanel.salesComment' })}</span>
        <div className="text-wrap">
          <span>{salesComment}</span>
        </div>
      </li>
    </ul>
  );
};

export const PriceImprovementSummary = connectPriceImprovementSummary(PriceImprovementSummaryRaw);
